import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-autocomplete" }
const _hoisted_2 = ["id", "disabled", "required", "invalid", "value", "placeholder", "aria-placeholder", "name"]
const _hoisted_3 = ["no-html-error-text"]

import {computed, onMounted, onUnmounted, ref} from 'vue';
    import {AddressResource} from '@/common/api/api-raw-types';
    import {LocationAutocomplete} from '@malt/location-autocomplete';

    export interface Props {
        address?: AddressResource;
        disabled?: boolean;
        msgError?: boolean;
        label?: string;
        name?: string;
        id?: string;
        error?: boolean;
        required?: boolean;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'LocationAutocomplete',
  props: {
    address: {},
    disabled: { type: Boolean, default: false },
    msgError: { type: Boolean, default: false },
    label: {},
    name: {},
    id: {},
    error: { type: Boolean },
    required: { type: Boolean }
  },
  emits: ["update:address"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const location = ref(null);
    const formattedAddress = computed(() => props.address?.formattedAddress);

    const locationAutocompleteInstance = ref<LocationAutocomplete>();

    onMounted(() => {
        locationAutocompleteInstance.value = new LocationAutocomplete({
            input: location.value,
            layer: 'LOCALITY',
            focusPoint: window.GEOLOCATION_FOCUS_POINT,
            defaultValue: props.address || null,
            onSelect: (lastSelected: AddressResource) => {
                emit('update:address', lastSelected);
            },
        });
    });

    onUnmounted(() => {
        locationAutocompleteInstance.value = null;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("joy-input", {
      id: _ctx.id,
      ref_key: "location",
      ref: location,
      disabled: _ctx.disabled,
      required: _ctx.required,
      invalid: _ctx.error,
      value: formattedAddress.value,
      placeholder: _ctx.$msg('generic.city.label'),
      "aria-placeholder": _ctx.$msg('generic.city.label'),
      name: _ctx.name,
      type: "text",
      autocomplete: "address-level4"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    (_ctx.error & _ctx.msgError)
      ? (_openBlock(), _createElementBlock("joy-form-error", {
          key: 0,
          "no-html-error-text": _ctx.$msg('form.field.error.message.required.generic')
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})